import { NumericFormat } from 'react-number-format'

export const CurrencyFormatLabel = ({
  value,
}: {
  value?: string | number | null
}) => {
  return (
    <NumericFormat
      prefix="$"
      displayType={'text'}
      thousandSeparator
      value={value}
      decimalScale={2}
      fixedDecimalScale
    />
  )
}
